module.exports = __webpack_public_path__ + "img/bookmark-plus-fill.57eb1ea9.svg";